var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"pt-0 main-home"},[_c('home'),_c('about'),_c('contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }